import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import OurPeople from './pages/OurPeople';
import OurInvestments from './pages/OurInvestments';
import SectorPage from './pages/SectorPage';
import Insights from './pages/Insights';
import Contact from './pages/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/our-people" element={<OurPeople />} />
            <Route path="/our-investments" element={<OurInvestments />} />
            <Route path="/information-technology" element={<SectorPage slug="information-technology" />} />
            <Route path="/gaming" element={<SectorPage slug="gaming" />} />
            <Route path="/property" element={<SectorPage slug="property" />} />
            <Route path="/entertainment" element={<SectorPage slug="entertainment" />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
